import { render } from "./CoveoAINotification.vue?vue&type=template&id=85204f26"
import script from "./CoveoAINotification.vue?vue&type=script&lang=js"
export * from "./CoveoAINotification.vue?vue&type=script&lang=js"

import "./CoveoAINotification.vue?vue&type=style&index=0&id=85204f26&lang=scss"

import exportComponent from "../../../../../../../../dow-corp/ui.frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__